import axiosInstance, {
  configMultiPartFormData,
  fetcher,
  revalidateOnlyStaleOptions,
} from 'src/utils/axios';
import useSWR from 'swr';
import { useMemo } from 'react';
import { ENDPOINTS } from './endpoints';

export async function getAppReleaseQrLink() {
  const ret = await axiosInstance.get(ENDPOINTS.app_release.get_qr_link);
  return ret.data;
}

export function useGetAppReleases() {
  const { data, isLoading, error, mutate } = useSWR(
    ENDPOINTS.app_release.get_list,
    fetcher,
    revalidateOnlyStaleOptions,
  );

  return useMemo(
    () => ({
      searchResults: data?.result || {},
      searchLoading: isLoading,
      searchError: error,
      refetch: mutate,
    }),
    [data?.result, error, isLoading, mutate],
  );
}

export async function uploadAppRelease({ file, releaseNote, isForceUpdate }) {
  const formData = new FormData();
  formData.append('File', file);
  if (releaseNote) formData.append('ReleaseNote', releaseNote);
  formData.append('IsForceUpdate', isForceUpdate ? 'true' : 'false');

  const ret = await axiosInstance.post(ENDPOINTS.app_release.post, formData, {
    ...configMultiPartFormData,
    timeout: 0,
  });
  return ret.data;
}

export async function updateAppReleaseActive(appReleaseId, isActive) {
  const ret = await axiosInstance.patch(ENDPOINTS.app_release.patch_active(appReleaseId), {
    isActive,
  });
  return ret.data;
}
